import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

class EditUserProfileContacts {
  public phoneNumber: string = '';
  public discordUsername: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    phoneNumber: [
      (v: string) => !!v || 'Phone is required',
    ],
    discordUsername: [
      (v: string) => !!v || 'Discord Username is required',
    ],
  };
}

class EditUserProfileCompanyDetails {
  public department: string = '';
  public position: string = '';
  public firstDay: string = '';
  public lastDay?: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    department: [
      (v: string) => !!v || 'Department is required',
      (v: string) => v.length >= 3 || 'Department has to be at least 3 characters',
    ],
    position: [
      (v: string) => !!v || 'Position is required',
      (v: string) => v.length >= 3 || 'Position has to be at least 3 characters',
    ],
    firstDay: [
      (v: string) => !!v || 'First Date is required',
    ],
  };
}

class EditUserProfilePersonalDetails {
  public firstName: string = '';
  public lastName: string = '';
  public fullName: string = '';
  public birthDate: string = '';
  public image: File = {} as File;

  public rules: { [key: string]: FormValidationFunction[] } = {
    firstName: [
      (v: string) => !!v || 'First Name is required',
      (v: string) => v.length >= 3 || 'First Name has to be at least 3 characters',
    ],
    lastName: [
      (v: string) => !!v || 'Last Name is required',
      (v: string) => v.length >= 3 || 'Last Name has to be at least 3 characters',
    ],
    fullName: [
      (v: string) => !!v || 'Full Name is required',
      (v: string) => v.length >= 3 || 'Full Name has to be at least 3 characters',
    ],
    birthDate: [
      (v: string) => !!v || 'Birth Date is required',
    ],
    image: [
      (v: File) => Math.ceil(v.size / 1024) <= 5000 || !!v || 'Image size must be maximum 5mb',
    ],
  };
}

export class EditUserProfileForm {
  public userId: string = '';
  public personalDetails: EditUserProfilePersonalDetails = new EditUserProfilePersonalDetails();
  public companyDetails: EditUserProfileCompanyDetails = new EditUserProfileCompanyDetails();
  public contacts: EditUserProfileContacts = new EditUserProfileContacts();

  [key: string]: string | EditUserProfileContacts | EditUserProfilePersonalDetails
    | EditUserProfileCompanyDetails | { [key: string]: FormValidationFunction[] };

  public rules: { [key: string]: FormValidationFunction[] } = {
    userId: [
      (v: string) => !!v || 'UserId is required',
    ],
  };
}
